import React from 'react'

const CoreValues = () => {
  return (
    <div className="container core-values-section" data-aos="fade-up">
    <h2 className="text-center mb-5 sectionss-title p-3">
      OUR CORE VALUES
    </h2>
    <div >
      <div className="w-75 mx-auto value-box" >
        <div className="icon-box">
          <i class="bi bi-balloon-heart-fill"></i>
        </div>
        <h4 className="value-title">B - Beneficial</h4>
        <p >
          At Bsecure, we are dedicated to ensuring that our financial solutions
          provide tangible benefits to our clients...
        </p>
      </div>
      <div className="w-75 mx-auto value-box">
        <div className="icon-box">
          <i class="bi bi-person-raised-hand"></i>
        </div>
        <h4 className="value-title">S - Supportive</h4>
        <p>
          We pride ourselves on being a supportive partner throughout the
          financial journey...
        </p>
      </div>
      <div className="w-75 mx-auto value-box">
        <div className="icon-box">
          <i class="bi bi-escape"></i>
        </div>
        <h4 className="value-title">E - Ethical</h4>
        <p>
          Integrity and transparency are at the heart of Bsecure’s operations...
        </p>
      </div>
    </div>
  
    <div>
      <div className="w-75 mx-auto value-box">
        <div className="icon-box">
          <i class="bi bi-people-fill"></i>
        </div>
        <h4 className="value-title">C - Customer-Centric</h4>
        <p>
          Our services are designed with the client in mind. We prioritize
          understanding the unique needs of each individual or business...
        </p>
      </div>
      <div className="w-75 mx-auto value-box">
        <div className="icon-box">
          <i class="bi bi-globe-central-south-asia"></i>
        </div>
        <h4 className="value-title">U - Understanding</h4>
        <p>
          We recognize that each client’s financial situation is unique. At
          Bsecure, we make it a priority to empathize with our clients'
          circumstances...
        </p>
      </div>
      <div className="w-75 mx-auto value-box">
        <div className="icon-box">
          <i class="bi bi-check-circle-fill"></i>
        </div>
        <h4 className="value-title">R - Reliable</h4>
        <p>
          Reliability is a cornerstone of our service. Clients can count on
          Bsecure to deliver on our promises and provide consistent, dependable
          support...
        </p>
      </div>
      <div className="w-75 mx-auto value-box">
        <div className="icon-box">
          <i class="bi bi-star-fill"></i>
        </div>
        <h4 className="value-title">E - Excellence</h4>
        <p>
          We strive for excellence in every aspect of our services...
        </p>
      </div>
    </div>
  </div>
  

  )
}

export default CoreValues
